import { ScrollView, ScrollViewTransform } from "../ScrollView.js";
import { ScrollViewScale } from "../scrollviewscale/ScrollViewScale.js";
import { IScrollViewResize } from "./IScrollViewResize.js";

export class ScrollViewResizeContain implements IScrollViewResize {

    constructor(public maxScale:number = Number.MAX_VALUE){

    }

    public getTransform(view: ScrollView, widthBefore: number, heightBefore: number): ScrollViewTransform {
        var scale = Math.min(ScrollViewScale.Contain.getScale(view), this.maxScale);
        return {
            scale: scale,
            x: view.width * 0.5 - (view.contentWidth * 0.5) * scale,
            y: view.height * 0.5 - (view.contentHeight * 0.5) * scale
        };
    }
}